import { QueryString } from '@/Core/config/query-mappings';

export default {
  data() {
    return {
      search: this.$route.query.search || null,
    };
  },
  methods: {

    /**
     * Updates the fields provided in newQuery on the current $route.query
     *
     * @param {Object} newQuery Query fields to be updated
     * @return new $route.query
     */
    $_search_updateQueryString(newQuery) {
      return Object.assign({}, this.$route.query, newQuery);
    },

    /**
     * Prepare $keywords for API query
     *
     * @param {Object} query $route.query object
     * @return $route.query search or empty string
     */
    $_search_prepareKeywords(query) {
      return query[QueryString.Search] || '';
    },

    /**
     * The pagination query string uses shorthands for limit (l)
     * and skip (p, for page).
     */
    searchRemoveShorthandKeys(query) {
      delete query.search;
    },

    /**
     * Pushes new search value to $route.query
     *
     * @param {String} search
     */
    setSearch(search) {
      this.search = search;
      const query = this.$_search_updateQueryString({
        [QueryString.Search]: search,
        [QueryString.Page]: 1,
      });
      this.$router.push({ query });
    },
  },
};
